import EmbeddedFormPage from './EmbeddedFormPage';

const SubsidyPrepaymentPage = () => (
  <EmbeddedFormPage
    titleKey="Subsidy Prepayment"
    description="Fill out this form to apply for Subsidy Prepayment. Subsidy Prepayment advances your subsidy payments so you have steady cash flow while you wait for state reimbursement."
    formUrl="https://wonderschool.fillout.com/t/wTwh2ggco1us"
    prefillDirectorContact
  />
);

export default SubsidyPrepaymentPage;
